<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="ser">
<p class="rvh">Praise for <i>Woman Up</i></p>
<p class="rvf">“In the media studies scholarship analyzing the torrent of recent female-centered television, Julia Havas’s book stands out for its rigorous examination of series whose formal experimentation is matched by self-conscious engagement with popular feminism. Her sterling contribution to this literature reminds us how exciting it is to see new feminist research frontiers being mapped and charted.”</p>
<p class="rvt">—Diane Negra, professor of film studies and screen culture, University College Dublin</p>
<p class="rvf">“Julia Havas opens provocative questions about television series like <i>30 Rock</i> that have been progressive favorites in the postfeminist era. Her savvy insights about marketable feminism and the meanings of ‘quality’ TV will have you re-watching and re-thinking your favorite episodes. Exploring the politics and aesthetics of both television and representations of feminism, <i>Woman Up</i> is an original and refreshing read for fans and scholars alike.”</p>
<p class="rvt">—Linda Mizejewski, Ohio State University</p>
<p class="rvf">“In this essential reading for anyone interested in television studies, Julia Havas spotlights the field’s two most vital approaches: feminism and formalism. <i>Woman Up</i>’s deep dive into recent feminist quality TV theorizes and exemplifies how these critical lenses function optimally in tandem, rather than (all too often) in opposition.”</p>
<p class="rvt">—Julia Leyda, professor of film studies, Norwegian University of Science and Technology</p>
<p class="rvf">“Showing how profoundly and insistently quality television calls on feminist tropes, <i>Woman Up</i> challenges a predominate masculinist emphasis in scholarly accounts. An evocative reading of feminist quality television, and a powerful engagement with landmark shows, Havas’s book is a vital source for both television and feminist media studies.”</p>
<p class="rvt">—Yvonne Tasker, professor of media and communication, University of Leeds</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-havas-0002.vue?365686f8